export class EventTracker {
  pageView = data => {
    data = data || {};
    let oReq = new XMLHttpRequest();
    oReq.open("POST", "/siteapi/logs/pageview");
    oReq.overrideMimeType("application/json");
    data.referrer = document.referrer;
    data.origin_full_url = window.location;
    data.origin_path = window.location.pathname;
    oReq.send(JSON.stringify(data));
  };

  trackEvent = data => {
    data = data || {};
    let oReq = new XMLHttpRequest();
    oReq.open("POST", "/siteapi/logs/event");
    oReq.overrideMimeType("application/json");
    data.referrer = document.referrer;
    data.origin_full_url = window.location;
    data.origin_path = window.location.pathname;
    oReq.send(JSON.stringify(data));
  };
}
global.EventTracker = EventTracker;



// WEBPACK FOOTER //
// ./app/scripts/events.jsx